import { ModuleName, PROVIDER_TYPE_MAP } from '@utils/constants';
import useModules from '@utils/hooks/useModules';
import { useGetIntegrations } from './useGetIntegrations';
import { ProviderCode } from '@interfaces/Integration';

export const useIntegrations = () => {
  const { hasModule } = useModules();
  const { integrations } = useGetIntegrations();

  const hasCommercePurchasedModule = (providerType: keyof typeof PROVIDER_TYPE_MAP) => {
    const purchasedModules = {
      [PROVIDER_TYPE_MAP.delivery.key]: hasModule(ModuleName.PROVEEDORES_ENTREGA),
      [PROVIDER_TYPE_MAP.tpv.key]: hasModule(ModuleName.LOYVERSE), // Cambio específico para Loyverse
      [PROVIDER_TYPE_MAP.payment.key]: hasModule(ModuleName.PROVEEDORES_PAGO),
      [PROVIDER_TYPE_MAP.communication.key]: hasModule(ModuleName.NOTIFICACIONES_CLIENTE_WHATSAPP),
      [PROVIDER_TYPE_MAP.tools.key]: hasModule(ModuleName.PLICK_PRINT_SERVER),
    };

    return purchasedModules[providerType];
  };

  const getIntegration = (providerCode: ProviderCode) => {
    return integrations.find((integration) => integration.provider_code === providerCode);
  };

  const hasIntegration = (providerType: keyof typeof PROVIDER_TYPE_MAP) => {
    return integrations.some((integration) => integration.provider_type === providerType);
  };

  const hasDeliveryIntegrations = integrations.some(
    (integration) => integration.provider_type === PROVIDER_TYPE_MAP.delivery.key,
  );

  return {
    hasCommercePurchasedModule,
    getIntegration,
    hasIntegration,
    hasDeliveryIntegrations,
  };
};
